import { TFunction } from 'i18next';
import { ListingType, JobPriority } from '../types/job';
import { CreditActionType } from '../types/credits';

export function mapListingTypesToPriorities(
  listingTypes: ListingType[],
  t: TFunction,
  actionCosts: Record<CreditActionType, number>
): JobPriority[] {
  return listingTypes.map(lt => {
    const priorityKey = lt.code as 'standard' | 'featured' | 'urgent';

    const actionType = lt.credit_action_type || `publish_job_${priorityKey}`;
    const cost = actionCosts[actionType] || 0;

    return {
      id: lt.id,
      key: lt.code,
      cost: cost,
      label: t(`publish.priorities.${priorityKey}.label`),
      description: t(`publish.priorities.${priorityKey}.description`),
      details: t(`publish.priorities.${priorityKey}.details`, { count: cost }),
    } as JobPriority;
  });
}
